import {HttpEvent, HttpEventType, HttpResponse} from '@angular/common/http';
import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject} from 'rxjs';
import {ApiService, HttpError} from '../../shared/api.service';

@Component({
  selector: 'talent-link',
  templateUrl: './talent-link.component.html',
  styleUrls: ['./talent-link.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class TalentLinkComponent implements OnChanges {

  @Input() link: Talent.PortfolioOrContactUrl;
  @Input() submittalProfileId: string;
  @Input() editable: boolean;

  @Output() update = new EventEmitter<Talent.PortfolioOrContactUrl>();
  @Output() delete = new EventEmitter<void>();

  uploadable$ = new BehaviorSubject(false);
  errorMessage$ = new BehaviorSubject('');
  uploadProgress$ = new BehaviorSubject(0);
  uploading$ = new BehaviorSubject(false);
  dragOver$ = new BehaviorSubject(false);

  constructor(private Api: ApiService,
              private Translate: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.link && this.link.type === 'Resume') {
      this.link.url = this.Api.getTalentResumeLink(this.submittalProfileId);
    }
    this.uploadable$.next(this.editable && (!this.link || this.link.type === 'Resume'));
  }

  dragEnter(event: DragEvent) {
    if (this.uploadable$.getValue()) {
      this.dragOver$.next(true);
      event.stopPropagation();
      event.preventDefault();
    }
  }

  dragLeave(event: DragEvent) {
    if (this.uploadable$.getValue()) {
      this.dragOver$.next(false);
      event.stopPropagation();
      event.preventDefault();
    }
  }

  dropUpload(event: DragEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.dragOver$.next(false);
    this.uploadFile(event.dataTransfer.files);
  }

  uploadFile(files: FileList) {
    this.errorMessage$.next('');

    if (this.uploadable$.getValue() && files.length === 1) {
      this.uploadProgress$.next(0);
      this.uploading$.next(true);

      this.Api.replaceResume(this.submittalProfileId, files[0])
        .subscribe((event: HttpEvent<any>) => this.handleUploadEvent(event),
          (err: HttpError) => this.handleUploadError(err));
    }
  }

  handleUploadEvent(event: HttpEvent<string>) {
    if (event.type === HttpEventType.UploadProgress) {
      const progress = Math.round(100 * event.loaded / event.total);
      this.uploadProgress$.next(progress);
    } else if (event.type === HttpEventType.Response) {
      this.handleUploadResponse(event);
    }
  }

  handleUploadResponse(event: HttpResponse<string>) {
    const body: Talent.PortfolioOrContactUrl = JSON.parse(event.body);
    this.uploading$.next(false);

    if (body.url) {
      this.update.emit(body);
    } else {
      console.error('Failed to upload resume: ' + event.body);
      this.errorMessage$.next(this.Translate.instant('talent-profile.link-upload-error'));
    }
  }

  handleUploadError(err: HttpError) {
    console.error('Failed to upload resume: ' + err.code);
    const errorKey = err.status === 413 ? 'talent-profile.link-upload-too-large' : 'talent-profile.link-upload-error';
    this.errorMessage$.next(this.Translate.instant(errorKey));
    this.uploading$.next(false);
  }

  remove() {
    this.delete.emit();
  }

}
